
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as test1gYpOS5lEE8aDLzKFCpuf6ND_45tOoazwhm3EyMvxJqvkMeta } from "/opt/atlassian/pipelines/agent/build/pages/test.vue?macro=true";
import { default as searchkSoZtKisAmQzUryIh0rqXTj4XbHTQQLxHrdvFoxZHgUMeta } from "/opt/atlassian/pipelines/agent/build/pages/search.vue?macro=true";
import { default as barcodeoCmY_6macwM57w28uvKpkP3XK6MwE7plf9QCQr_zubIMeta } from "/opt/atlassian/pipelines/agent/build/pages/barcode.vue?macro=true";
import { default as test500iZMIouxdypeMe7OQvVAZvGpS65QK_455pQfOC7IQBNmJwMeta } from "/opt/atlassian/pipelines/agent/build/pages/test500.vue?macro=true";
import { default as _91_46_46_46slug_93D83QY4Qi4ch3jphOOqWb3ZYLsOmqQTlPyJDYEQxD1ZIMeta } from "/opt/atlassian/pipelines/agent/build/pages/[...slug].vue?macro=true";
import { default as barcodelookupt2wSFq7vdXraB_12xL0KU8UdoBLAkSyPBb7wFuty3FoMeta } from "/opt/atlassian/pipelines/agent/build/pages/barcodelookup.vue?macro=true";
import { default as tailwindfixes9iLDvzW_45zryN68WdUfZpLpe8XJ20r5utsMLdYjxLy9UMeta } from "/opt/atlassian/pipelines/agent/build/pages/tailwindfixes.vue?macro=true";
import { default as inviteL08O2dhrQswegKsEcyj_QgsEpl7AKiaAAEU_45cRe5wkgMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/invite.vue?macro=true";
import { default as signin_7hmyHztEyRSRED_69hNfCnjkZ_45EsXXCkuYpa0SqK7AMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/signin.vue?macro=true";
import { default as index0IMX2sxtyrLT45WhPQQTA_45gmytwE6jFl0prGzxO_PDwMeta } from "/opt/atlassian/pipelines/agent/build/pages/checkout/index.vue?macro=true";
import { default as _91_46_46_46slug_93mlV0nE2eGSLePX3z7lycYyO47_45U8kKpeGpbkvX73s10Meta } from "/opt/atlassian/pipelines/agent/build/pages/account/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93dfYKx6THdQgdWi44_45wevwe_45UFwlldfilz1U3ILwrIqwMeta } from "/opt/atlassian/pipelines/agent/build/pages/salestool/[...slug].vue?macro=true";
import { default as indexyKeWN5J4MRa_45zgl9cS_45Gh5_bTlHOpa9sUXU1n46eh_oMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/signup/index.vue?macro=true";
import { default as successShkpoEzNv5litY4WISbYaEBrAVH717G5oTQqdgeL8yoMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/signup/success.vue?macro=true";
import { default as welcomeb2nZEfGbBZcGEsN_DrFgxDvV9f_45eDN8Vui1tqfbAkz4Meta } from "/opt/atlassian/pipelines/agent/build/pages/account/signup/welcome.vue?macro=true";
import { default as formValidationTemplatecmah_45YROUY0wyA3TAfJVi35jseV0J_45adk2557UITYYIMeta } from "/opt/atlassian/pipelines/agent/build/pages/formValidationTemplate.vue?macro=true";
import { default as _91cartId_93WoeJTieuD_p8Ko2E3AviBe_45PplzIYOWgM6sJ7Mp7YIEMeta } from "/opt/atlassian/pipelines/agent/build/pages/checkout/[result]/[cartId].vue?macro=true";
import { default as _91basketId_93VS6iA3Jlvp2rrMIEgChDL9naNZzFQyRVT_5_uIUzGu0Meta } from "/opt/atlassian/pipelines/agent/build/pages/checkout/pointshop/[basketId].vue?macro=true";
import { default as _91token_93PuovQFUQFbNImsTWhqCJl0_yGCaWOGFRgnoChjsg4FsMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/resetpassword/[email]/[token].vue?macro=true";
export default [
  {
    name: "test",
    path: "/test",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/test.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/search.vue")
  },
  {
    name: "barcode",
    path: "/barcode",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/barcode.vue")
  },
  {
    name: "test500",
    path: "/test500",
    meta: test500iZMIouxdypeMe7OQvVAZvGpS65QK_455pQfOC7IQBNmJwMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/test500.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93D83QY4Qi4ch3jphOOqWb3ZYLsOmqQTlPyJDYEQxD1ZIMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[...slug].vue")
  },
  {
    name: "barcodelookup",
    path: "/barcodelookup",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/barcodelookup.vue")
  },
  {
    name: "tailwindfixes",
    path: "/tailwindfixes",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/tailwindfixes.vue")
  },
  {
    name: "account-invite",
    path: "/account/invite",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/invite.vue")
  },
  {
    name: "account-signin",
    path: "/account/signin",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/signin.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/index.vue")
  },
  {
    name: "account-slug",
    path: "/account/:slug(.*)*",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/[...slug].vue")
  },
  {
    name: "salestool-slug",
    path: "/salestool/:slug(.*)*",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/salestool/[...slug].vue")
  },
  {
    name: "account-signup",
    path: "/account/signup",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/signup/index.vue")
  },
  {
    name: "account-signup-success",
    path: "/account/signup/success",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/signup/success.vue")
  },
  {
    name: "account-signup-welcome",
    path: "/account/signup/welcome",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/signup/welcome.vue")
  },
  {
    name: "formValidationTemplate",
    path: "/formValidationTemplate",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/formValidationTemplate.vue")
  },
  {
    name: "checkout-result-cartId",
    path: "/checkout/:result()/:cartId()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/[result]/[cartId].vue")
  },
  {
    name: "checkout-pointshop-basketId",
    path: "/checkout/pointshop/:basketId()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/pointshop/[basketId].vue")
  },
  {
    name: "account-resetpassword-email-token",
    path: "/account/resetpassword/:email()/:token()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/resetpassword/[email]/[token].vue")
  }
]